import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Alert from "../../components/Alert";
import { createLookupApi } from "../../api/lookupApi";
import { listShortCodes, saveShortCode, deleteShortCode } from "../../api/examApi";
import "../Users/UsersPage.css";
import "../Attendance/Attendance.css";

const classApi = createLookupApi("classes");
const emptyForm = { shortCodeTitle: "", shortCodeNote: "", defaultId: 1, totalMark: 100, passMark: 33, acceptance: 1 };

/** Mark components (CT/Written/Assignment/...) defined per class — the building blocks a subject's mark configuration picks from. */
export default function ShortCodePage() {
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [shortCodes, setShortCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    classApi.list().then((list) => {
      setClasses(list);
      if (list.length > 0) setClassId(String(list[0].id));
    });
  }, []);

  const load = () => {
    if (!classId) return;
    setLoading(true);
    listShortCodes(classId)
      .then(setShortCodes)
      .catch(() => setError("Failed to load short codes."))
      .finally(() => setLoading(false));
  };

  useEffect(load, [classId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await saveShortCode({ ...form, classId: Number(classId), defaultId: Number(form.defaultId), totalMark: Number(form.totalMark), passMark: Number(form.passMark), acceptance: Number(form.acceptance) });
      setSuccess("Short code saved.");
      setForm(emptyForm);
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to save.");
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm(`Delete short code "${row.shortCodeTitle}"?`)) return;
    setError("");
    try {
      await deleteShortCode(row.shortCodeId);
      setSuccess("Deleted.");
      setShortCodes((prev) => prev.filter((s) => s.shortCodeId !== row.shortCodeId));
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to delete.");
    }
  };

  const columns = [
    { key: "shortCodeTitle", label: "Title" },
    { key: "defaultId", label: "Slot (1-8)" },
    { key: "totalMark", label: "Total Mark" },
    { key: "passMark", label: "Pass Mark" },
    { key: "acceptance", label: "Weight" },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Short Code Setup</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      <div className="attendance-filters">
        <label>
          Class
          <select value={classId} onChange={(e) => setClassId(e.target.value)}>
            {classes.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      <form onSubmit={handleSubmit} className="user-form" style={{ marginTop: 16, marginBottom: 24 }}>
        <label>Title *</label>
        <input value={form.shortCodeTitle} onChange={(e) => setForm({ ...form, shortCodeTitle: e.target.value })} required placeholder="e.g. CT, Written, Assignment" />
        <label>Slot (1-8, unique per class)</label>
        <input type="number" min="1" max="8" value={form.defaultId} onChange={(e) => setForm({ ...form, defaultId: e.target.value })} />
        <label>Total Mark</label>
        <input type="number" value={form.totalMark} onChange={(e) => setForm({ ...form, totalMark: e.target.value })} />
        <label>Pass Mark</label>
        <input type="number" value={form.passMark} onChange={(e) => setForm({ ...form, passMark: e.target.value })} />
        <label>Weight (acceptance)</label>
        <input type="number" step="0.01" value={form.acceptance} onChange={(e) => setForm({ ...form, acceptance: e.target.value })} />
        <div className="form-actions">
          <button type="submit" className="btn-primary">
            + Add Short Code
          </button>
        </div>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={shortCodes}
          actions={(row) => (
            <button type="button" className="btn-link danger" onClick={() => handleDelete(row)}>
              Delete
            </button>
          )}
        />
      )}
    </MainLayout>
  );
}
